import { render, staticRenderFns } from "./jzcommon.vue?vue&type=template&id=0df28172&scoped=true"
import script from "./jzcommon.vue?vue&type=script&lang=js"
export * from "./jzcommon.vue?vue&type=script&lang=js"
import style0 from "./jzcommon.vue?vue&type=style&index=0&id=0df28172&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df28172",
  null
  
)

export default component.exports